/* global navigator */

const GEO_TIMEOUT_MS = 8000

export class WorkOrderForm {
  constructor () {
    this.latitude = document.getElementById('workOrderLatitude')
    this.longitude = document.getElementById('workOrderLongitude')
    this.status = document.getElementById('workOrderGeoStatus')
    this.watchId = null
  }

  init () {
    if (!this.latitude || !navigator.geolocation) { return }
    this.setStatus('Getting location...')
    this.watchId = navigator.geolocation.watchPosition(
      position => this.setCoordinates(position.coords),
      () => this.setStatus('Location unavailable.'),
      { timeout: GEO_TIMEOUT_MS, enableHighAccuracy: true }
    )
  }

  setCoordinates (coords) {
    this.latitude.value = coords.latitude
    this.longitude.value = coords.longitude
    this.setStatus('Location captured.')
  }

  setStatus (text) {
    if (this.status) { this.status.textContent = text }
  }
}
